/**
 * General scripts
 *
 * This file should contain any scripts needed. Instead of calling it in the header
 * or throwing it inside wp_head(), this file will be called automatically in the
 * footer for better performance.
 *
 * @package   seedyjoints
 * @since     JointsWP
 * @author    <corey@chatmandesign.com>
 * @link      http://chatmandesign.com
 */

(function($) {

	//! – FUNCTIONS

	function cd_responsive_scripts() {
		if (Foundation.MediaQuery.atLeast('medium')) {
			// load gravatars
			$('.comment img[data-gravatar]').each(function(){
				$(this).attr('src',$(this).attr('data-gravatar'));
			});
		}
	}

	//! – DOM READY

	$(function() {

		//! –– POLYFILLS & FALLBACKS

		/**
		 * Makes "skip to content" link work correctly in Chrome (and IE9) for better
		 * accessibility. From Twenty Fourteen.
		 *
		 * @link http://www.nczonline.net/blog/2013/01/15/fixing-skip-to-content-links/
		 */
		$(window).on( 'hashchange', function() {
			var element = document.getElementById( location.hash.substring( 1 ) );

			if ( element ) {
				if ( ! /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) {
					element.tabIndex = -1;
				}

				element.focus();

				// Repositions the window on jump-to-anchor to account for header height.
				window.scrollBy( 0, -80 );
			}
		} );


		//! –– GENERAL SCRIPTS

		// Load Foundation
		$(document).foundation();

		// Setup responsive scripts
		$(window).on('changed.zf.mediaquery', () => cd_responsive_scripts());
		cd_responsive_scripts();

	}); // jQuery document ready


	//! – ALL ASSETS LOADED

	/*
	$(window).on('load', function () {

	});
	*/
})(jQuery);
